import React, { useEffect, useRef } from 'react';
import Translate from './translate';

const Asseenon = () => {
  const logosRef = useRef<HTMLUListElement>(null);

  useEffect(() => {
    const ul = logosRef.current;
    if (ul) {
      const clone = ul.cloneNode(true) as HTMLElement;
      clone.setAttribute('aria-hidden', 'true');
      ul.parentNode?.appendChild(clone);
    }
  }, []);

  return (
    <div className="bg-[#27004F] py-8 px-0">
      <div className="container mx-auto w-full">  
        <div className="text-white text-center text-2xl font-bold mb-8 opacity-70">
          <Translate id="trustedByHeading" foldername="general" filename="asseenon" />
        </div>
        <div className="w-full inline-flex flex-nowrap overflow-hidden [mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-128px),transparent_100%)]">
          <ul ref={logosRef} className="opacity-90 flex items-center justify-center md:justify-start [&_li]:mx-8 [&_img]:max-w-none [&_img]:object-contain animate-infinite-scroll">
            <li>
              <img src="/asseenon/podnews.webp" alt="Podnews" style={{width: "160px"}} />
            </li>
            <li>
              <img src="/asseenon/transistorlogo.webp" alt="Transistor" style={{width: "176px"}} />
            </li>
            <li>
              <img src="/asseenon/thepodcasthost.webp" alt="The Podcast Host" style={{width: "176px"}} />
            </li>
            <li>
              <img src="/asseenon/schoolofpodcasting.webp" alt="School of Podcasting" style={{width: "152px"}} />
            </li>
            <li>
              <img src="/asseenon/semrush.webp" alt="SEMrush" style={{width: "176px"}} />
            </li>
            <li>
              <img src="/asseenon/businessinsider.webp" alt="Business Insider" style={{width: "100px"}} />
            </li>
            <li>
              <img src="/asseenon/observador-logo-color.png" alt="Observador" style={{height: "22px"}} />
            </li>
            <li>
              <img src="/asseenon/bauher-logo-color.png" alt="Bauer Media Audio Portugal" style={{height: "48px"}} />
            </li>
            <li>
              <img src="/asseenon/expresso-logo-color.png" alt="Expresso" style={{height: "32px"}} />
            </li>
            <li>
              <img src="/asseenon/RR-logo-color.png" alt="Renascença" style={{height: "36px"}} />
            </li>
            <li>
              <img src="/asseenon/eco-logo-color.png" alt="ECO" style={{height: "42px"}} />
            </li>          
            <li>
              <img src="/asseenon/business-radio-x-color.png" alt="Business Radio X" style={{height: "48px"}} />
            </li>
            <li>
              <img src="/asseenon/audivita-color.png" alt="Audivita" style={{height: "32px"}} />
            </li>
            <li>
              <img src="/asseenon/interview-valet-color.png" alt="Interview Valet" style={{height: "48px"}} />
            </li>
            {/* Duplicate the list items here for seamless scrolling */}
            <li>
              <img src="/asseenon/podnews.webp" alt="Podnews" style={{width: "160px"}} />
            </li>
            <li>
              <img src="/asseenon/transistorlogo.webp" alt="Transistor" style={{width: "176px"}} />
            </li>
            <li>
              <img src="/asseenon/thepodcasthost.webp" alt="The Podcast Host" style={{width: "176px"}} />
            </li>
            <li>
              <img src="/asseenon/schoolofpodcasting.webp" alt="School of Podcasting" style={{width: "152px"}} />
            </li>
            <li>
              <img src="/asseenon/semrush.webp" alt="SEMrush" style={{width: "176px"}} />
            </li>
            <li>
              <img src="/asseenon/businessinsider.webp" alt="Business Insider" style={{width: "100px"}} />
            </li>
            <li>
              <img src="/asseenon/observador-logo-color.png" alt="Observador" style={{height: "22px"}} />
            </li>
            <li>
              <img src="/asseenon/bauher-logo-color.png" alt="Bauer Media Audio Portugal" style={{height: "48px"}} />
            </li>
            <li>
              <img src="/asseenon/expresso-logo-color.png" alt="Expresso" style={{height: "32px"}} />
            </li>
            <li>
              <img src="/asseenon/RR-logo-color.png" alt="Renascença" style={{height: "36px"}} />
            </li>
            <li>
              <img src="/asseenon/eco-logo-color.png" alt="ECO" style={{height: "42px"}} />
            </li>           
            <li>
              <img src="/asseenon/business-radio-x-color.png" alt="Business Radio X" style={{height: "48px"}} />
            </li>
            <li>
              <img src="/asseenon/audivita-color.png" alt="Audivita" style={{height: "32px"}} />
            </li>
            <li>
              <img src="/asseenon/interview-valet-color.png" alt="Interview Valet" style={{height: "48px"}} />
            </li>
          </ul>
        </div>
      </div>
      <style>{`
        @keyframes infinite-scroll {
          0% {
            transform: translateX(0%);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .animate-infinite-scroll {
          display: flex;
          animation: infinite-scroll 35s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default Asseenon;